import * as React from "react";
import "./style.scss";
import { SimpleLineChart } from "../../../../core/Chart";
import {
  processLineChartData,
  calculateLineTicks,
  formatDataForDaysSinceLaunch
} from "../../../../core/Chart/common/utils";
import {
  defaultYTickProps,
  defaultXTickProps,
  defaultYLabelProps,
  defaultXLabelProps
} from "../../../constants";

interface MetricGroupCompareLineChartProps {
  group_by: string;
  compare_by: string;
  metric: string;
  data: any[];
  fullscreen: boolean;
  onBrushChange?: () => void;
}

export class LineChart extends React.Component<
  MetricGroupCompareLineChartProps,
  {}
> {
  render() {
    let { group_by, compare_by, metric, data, fullscreen } = this.props;
    let chartData, chartTicks;
    const height = fullscreen ? "90%" : 450;

    if (data) {
      if (group_by == "date") {
        data = [...data].sort((a, b) =>
          String(a.date).localeCompare(String(b.date))
        );
      }

      // When grouping by data and comparing by publication, format data
      // to display 'days since launch' instead of date
      if (group_by == "date" && compare_by == "publication") {
        const dslGroupBy = "days_since_flyer_launch";
        data = formatDataForDaysSinceLaunch(data, dslGroupBy);
        group_by = dslGroupBy;
      }

      chartData = processLineChartData(data, group_by, compare_by, metric);
      chartTicks = calculateLineTicks(chartData, metric, group_by);
    }

    //PURE CSS uses flex box which interferes with recharts' resizableContainer's onscroll width recalculations
    //https://github.com/recharts/recharts/issues/172
    // to work around set width:99%
    return (
      <div className="analytics-line-chart" style={{ height: "100%" }}>
        {data && data.length > 0 ? (
          <SimpleLineChart
            containerProps={{
              height: height,
              width: "99%"
            }}
            chartProps={{
              data: chartData,
              valueKey: metric,
              compareKey: compare_by,
              groupingKey: group_by
            }}
            onBrushChange={this.props.onBrushChange}
            yAxisProps={{
              labelProps: defaultYLabelProps(metric),
              tickProps: { ...defaultYTickProps, ticks: chartTicks }
            }}
            xAxisProps={{
              labelProps: defaultXLabelProps(group_by),
              tickProps: defaultXTickProps
            }}
          />
        ) : (
          <div className="null-text">
            <span className="analytics-null-chart">
              There's no data available for the selected dropdowns.
              <br />
              Try changing the dropdowns to view data.
            </span>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/modules/AnalyticsMetric/components/Visualizations/LineChart/index.tsx